import type { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import type { Crumb } from '../components/common/BreadCrumb';

/* The package's ILink, which its entry point does not re-export. */
type AccountCrumb = ReturnType<typeof useAccountCrumbs>[number];

export const mapCrumbsToStaticCrumbs = (crumbs: AccountCrumb[]): Crumb[] => {
  return crumbs.map((crumb) => {
    return {
      label: crumb.label,
      url: crumb.path || '',
    };
  });
};
